import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ServicesGrid } from "@/components/sections/ServicesGrid";
import { CTAGroup } from "@/components/CTAGroup";
import { BRAND } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";

const Services = () => (
  <Layout>
    <Seo
      title="Flooring Services in Danbury, CT | LVT, Hardwood, Laminate & LVP"
      description="Luxury vinyl tile, hardwood, laminate, floor refinishing and luxury vinyl plank installation by VRP Flooring LLC — Danbury, CT's trusted flooring contractor."
      jsonLd={[
        orgSchema(),
        breadcrumbSchema([
          { name: "Home", url: BRAND.website },
          { name: "Services", url: `${BRAND.website}/services` },
        ]),
      ]}
    />
    <section className="container-page py-12 md:py-16">
      <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "Services" }]} />
      <div className="mt-6 max-w-3xl">
        <p className="eyebrow mb-4 text-accentInk">Our Services</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-5">Complete flooring services, under one roof.</h1>
        <p className="text-muted-foreground text-lg">From a single room to an entire building, our licensed installers handle luxury vinyl tile, hardwood, laminate, floor refinishing and luxury vinyl plank with the same craftsmanship-first mindset.</p>
      </div>
    </section>

    <section className="container-page pb-20">
      <ServicesGrid />
    </section>

    <section className="bg-foreground text-background py-20">
      <div className="container-page text-center max-w-2xl">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Not sure where to start?</h2>
        <p className="text-background/80 text-lg mb-8">Tell us about your space — we'll bring the samples to you and guide you to the right floor, timeline and budget.</p>
        <CTAGroup variant="onDark" className="justify-center" />
      </div>
    </section>
  </Layout>
);

export default Services;
